import { CreateUserRequest, UpdateUserRequest, UserRequest } from '../Types/userRequest';
import { API_URL, enrichedFetch } from './api';

export const createUserRequest = async (userRequest: CreateUserRequest): Promise<UserRequest> => {
  return enrichedFetch(`${API_URL}/user-requests`, {
    method: 'POST',
    body: JSON.stringify(userRequest),
    headers: {
      'Content-Type': 'application/json',
    },
  }) as Promise<UserRequest>;
};

export const updateUserRequest = async (
  id: string,
  updatedUserRequest: UpdateUserRequest
): Promise<UserRequest> => {
  return enrichedFetch(`${API_URL}/user-requests/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(updatedUserRequest),
    headers: {
      'Content-Type': 'application/json',
    },
  }) as Promise<UserRequest>;
};
